import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { MplButton, MplModal } from '../../';
import { StayInformedAnim } from '../../molecules/Animations';

export interface IClosePersonalEditorModalProps {
	isOpen: boolean;
	onClose(): void;
	onDiscard(): void;
}

export const ClosePersonalEditorModal: FC<IClosePersonalEditorModalProps> = ({
	onClose,
	isOpen,
	onDiscard,
}) => {
	const { t } = useTranslation(['profile', 'common']);

	return (
		<MplModal
			open={isOpen}
			icon={<StayInformedAnim />}
			testId="ClosePersonalEditorModal-MplModal"
			onBackDropClick={onClose}
			title={t('title.modal_title')}
			content={t('title.modal_message')}
			buttons={
				<>
					<MplButton fullWidth variant="text" onClick={onClose}>
						{t('button.return')}
					</MplButton>
					<MplButton fullWidth onClick={onDiscard}>
						{t('button.discard')}
					</MplButton>
				</>
			}
		/>
	);
};
